import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import classNames from "classnames";
import * as React from "react";
import { useTranslation, Trans } from "react-i18next";
import Dropzone from "react-dropzone";
import TextFieldI18N from "../_components/TextFieldI18N";
import { serverUrl } from "../_constants";
import "../css/style.css";


const LANG_LIST = ["ru", "en", "cn"];

export default function MemberDialog(props) {
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [comment, setComm] = React.useState("");
  const [count, setCount] = React.useState(0);

  const [name_i18n, setNameI18N] = React.useState({});
  const [comment_i18n, setCommI18N] = React.useState({});

  const {
    handleClose,
    label,
    title,
    dialogOpen,
    dName,
    dMail,
    dComm,
    dNameI18N,
    dCommI18N,
    id,
    image,
    uploadImage,
    imageStatus,
  } = props;

  const { t } = useTranslation();

  React.useEffect(() => {
    if (count == 0 && dialogOpen) {
      setName(dName);
      setEmail(dMail);
      setComm(dComm);
      setNameI18N(dNameI18N);
      setCommI18N(dCommI18N);

      setCount(1);
    }
  });

  function saveData(e) {
    e.preventDefault();

    if (name != "" || (name_i18n && name_i18n["ru"])) {
      handleClose({ name, email, comment, name_i18n, comment_i18n });
      setCount(0);
    }
  }

  function cancelData() {
    handleClose("");
    setCount(0);
  }

  function onDrop(acceptedFiles, rejectedFiles) {
    console.log(acceptedFiles);

    if (acceptedFiles.length > 0) {
      // this.setState({ selectedFile: acceptedFiles[0],loadedProgress: 0, uploadState:0});

      props.uploadImage(acceptedFiles[0]);
    }
  }

  return (
    <Dialog open={dialogOpen}>
      <DialogTitle>{title}</DialogTitle>
      <form onSubmit={saveData}>
        <DialogContent>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Dropzone onDrop={onDrop} class="visually--hidden">
              {({ getRootProps, getInputProps, isDragActive }) => (
                <div
                  style={{
                    textAlign: "center",
                    verticalAlign: "center",
                    width: 250,
                    height: 250,
                    background: "#eee",
                    borderRadius: 5,
                    border: "1px solid #000",
                  }}
                  {...getRootProps()}
                  className={classNames("dropzone", {
                    "dropzone--isActive": isDragActive,
                  })}
                >
                  <input {...getInputProps()} />

                  {image && imageStatus == 0 && (
                    <img
                      src={image ? serverUrl + image : ""}
                      alt=""
                      className="object-cover"
                    />
                  )}
                  {imageStatus == 0 &&
                    (isDragActive ? (
                      <p
                        style={{
                          fontSize: 12,
                          position: "relative",
                          top: 110,
                          left: 15,
                        }}
                      >
                        {t("dropzone_file_upload")}
                      </p>
                    ) : (
                      <p
                        style={{
                          fontSize: 12,
                          position: "relative",
                          top: image ? -135 : 100,
                          left: 15,
                          width: 220,
                          background: "#eee",
                          padding: 10,
                          borderRadius: 5,
                        }}
                      >
                        {t("dropzone_title_hint")}
                      </p>
                    ))}
                  {imageStatus == 1 && (
                    <p
                      style={{
                        fontSize: 12,
                        position: "relative",
                        top: 110,
                      }}
                    >
                      {t("dropzone_file_uploaded")}
                    </p>
                  )}
                </div>
              )}
            </Dropzone>
          </div>
          <TextFieldI18N
            autoFocus
            margin="dense"
            id="name"
            label={t("dialog_brand")}
            fullWidth
            variant="standard"
            value={name_i18n}
            required
            onChange={(e, tabName) => {
              let tmpI18N = name_i18n;
              tmpI18N[tabName] = e.target.value;

              setNameI18N(tmpI18N);
              setName(tmpI18N["ru"]);
              setCount(count + 1);
            }}
            langList={LANG_LIST}
          />
          <TextField
            margin="dense"
            id="email"
            label={t("dialog_email")}
            fullWidth
            variant="standard"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setCount(count + 1);
            }}
          />
          <TextFieldI18N
            margin="dense"
            id="comment"
            label={t("dialog_comment")}
            fullWidth
            variant="standard"
            value={comment_i18n}
            multiline
            langList={LANG_LIST}
            onChange={(e, tabName) => {
              let tmpI18N = comment_i18n;
              tmpI18N[tabName] = e.target.value;

              setCommI18N(tmpI18N);
              setComm(tmpI18N["ru"]);
              setCount(count + 1);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button type="submit">{t("btn_save")}</Button>
          <Button onClick={cancelData}>{t("btn_cancel")}</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
